/**
 * `tax_profile` — la fiscalité de la galerie (base galerie, 4.1).
 *
 * Un seul document par galerie. Les taux et le barème du droit de suite y sont
 * rangés pour que la galerie puisse les faire valider par son expert-comptable
 * sans toucher au code (9.2, question 3).
 */
import { z } from 'zod';
import { regimeTvaSchema } from '../tax/regimes.js';
import { bilingueSchema, CHAMPS_DOCUMENT, centimesPositifsSchema, idSchema, tauxPointsDeBaseSchema, withAudit, } from './commun.js';
/** Une tranche du barème du droit de suite. */
export const trancheDroitDeSuiteSchema = z.object({
    /** Borne haute de la tranche, en centimes ; `null` pour la dernière. */
    plafondCentimes: centimesPositifsSchema.nullable(),
    tauxPointsDeBase: tauxPointsDeBaseSchema,
});
export const baremeDroitDeSuiteSchema = z.object({
    seuilCentimes: centimesPositifsSchema,
    plafondCentimes: centimesPositifsSchema,
    tranches: z.array(trancheDroitDeSuiteSchema).min(1),
});
export const taxProfileSchema = withAudit(z.object({
    _id: idSchema,
    assujetti: z.boolean().default(true),
    numeroTva: z.string().optional(),
    regimeParDefaut: regimeTvaSchema.default('normal'),
    tauxNormalPointsDeBase: tauxPointsDeBaseSchema.default(2_000),
    tauxReduitPointsDeBase: tauxPointsDeBaseSchema.default(550),
    droitDeSuite: baremeDroitDeSuiteSchema,
    /** Mentions légales de facture, par régime. */
    mentions: z.partialRecord(regimeTvaSchema, bilingueSchema).default({}),
    delaiPaiementJours: z.int().min(0).default(30),
}));
export const taxProfileMiseAJourSchema = taxProfileSchema.omit(CHAMPS_DOCUMENT).partial();
//# sourceMappingURL=tax-profile.js.map